import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './app-spinner.component.html',
  styleUrls: ['../../../../node_modules/spinkit/css/spinkit.css'],
  encapsulation: ViewEncapsulation.None
})
export class AppSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/components/app-spinner/app-spinner.component.ts